import { Markup } from "interweave";
import cx from "classnames";
import { t } from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons";
import { JourneyDeadlineMessage } from "./JourneyDeadlineMessage";

interface JourneyWelcomeMessageProps {
  htmlText: string;
  userHasUpdates: boolean;
  isPrefillAnswersEnabled: boolean;
  /** The deadline for the journey, not to be confused with the expiry date for the partial answer set */
  journeyDeadline: Date | null;
  onHide(): void;
  onBackToUpdates(): void;
  createAndPrefillCollabDoc(): void;
}

function JourneyWelcomeMessage({
  htmlText,
  userHasUpdates,
  isPrefillAnswersEnabled,
  journeyDeadline,
  onBackToUpdates,
  onHide,
  createAndPrefillCollabDoc,
}: JourneyWelcomeMessageProps) {
  return (
    <div className="flex flex-col justify-between h-full grow">
      <div className="journey-custom-content welcome-message flex flex-1 items-start py-4">
        <Markup content={htmlText} />
      </div>
      {journeyDeadline && (
        <div className="my-2 text-white">
          <JourneyDeadlineMessage deadline={journeyDeadline} />
        </div>
      )}
      <div
        className={cx(
          "mt-4",
          userHasUpdates
            ? "flex flex-row justify-between items-end"
            : "text-right",
        )}
      >
        {userHasUpdates && (
          <button
            className="text-white/70 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent"
            onClick={onBackToUpdates}
            type="button"
          >
            <FontAwesomeIcon icon={faArrowLeftLong} />
            <span> {t("Common.Back", "Back")}</span>
          </button>
        )}
        <button
          className="bg-white font-medium text-gray-700 rounded-md px-6 py-2 shadow-md hover:shadow-md hover:shadow-white/20 text-center"
          onClick={
            !isPrefillAnswersEnabled ? onHide : createAndPrefillCollabDoc
          }
        >
          {t("Journey.Button.StartJourney")}
        </button>
      </div>
    </div>
  );
}

export default JourneyWelcomeMessage;
